import React from 'react';
import { TripGridSkeleton } from '../../components/skeletons/TripCardSkeleton';
import { useFavoritesData } from '../../hooks/favorites/useFavoritesData';
import { FavoritesHeader } from './FavoritesHeader';
import { FavoritesGrid } from './FavoritesGrid';
import { EmptyFavoritesState } from './EmptyFavoritesState';
import { FavoritesErrorState } from './FavoritesErrorState';

/**
 * Favorites page component - refactored to separate business logic from UI.
 * All business logic is now in custom hooks, making it reusable for React Native.
 */
export const FavoritesPage = React.memo(() => {
  // Business logic hooks (platform-agnostic)
  const { favoritesByYear, isLoading, error, hasFavorites, unfavoriteTrip } = useFavoritesData();

  // Handlers
  const handleUnfollow = async (tripId: string, linkSecret: string | null, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    await unfavoriteTrip(tripId, linkSecret);
  };

  return (
    <div className="min-h-screen bg-subtle">
      <FavoritesHeader />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        {isLoading && <TripGridSkeleton />}

        {!isLoading && !hasFavorites && !error && <EmptyFavoritesState />}

        {!isLoading && hasFavorites && (
          <FavoritesGrid favoritesByYear={favoritesByYear} onUnfollow={handleUnfollow} />
        )}

        {error && <FavoritesErrorState />}
      </div>
    </div>
  );
});
